import { gql } from "@apollo/client";

export const FETCH_DIVISIONS = gql`
  query GetDivisions {
    findAllDivisions {
      costOfSales
      grossMargin
      name
      revenue
      uuid
      isDefault
    }
  }
`;

export const CREATE_DIVISION = gql`
  mutation division($data: CreateDivisionFinancialInput!) {
    createDivision(data: $data) {
      costOfSales
      grossMargin
      name
      revenue
      uuid
    }
  }
`;

export const EDIT_DIVISION = gql`
  mutation division($data: UpdateDivisionFinancialInput!) {
    updateDivision(data: $data) {
      costOfSales
      grossMargin
      name
      revenue
      uuid
    }
  }
`;

export const DELETE_DIVISION = gql`
  mutation divisionRemove($uuid: ID!) {
    deleteDivision(uuid: $uuid) {
      costOfSales
      grossMargin
      name
      revenue
      uuid
    }
  }
`;
